// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataTableProps } from "@insite/mobius/DataTable";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { TypographyProps } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { getNotifyStyle } from "@synd/App/Components/Notify";
import { mergeWithCss } from "@synd/XDL/Utilities";
import { css } from "styled-components";

interface DataTableStyles {
    container?: InjectableCss;
    dataTable?: DataTableProps;
    noResultsContainer?: InjectableCss;
    noResultsText?: TypographyProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
}

const dataTableStyles: DataTableStyles = {
    noResultsContainer: {
        css: css`
            text-align: center;
        `,
    },
    noResultsText: {
        ...mergeWithCss(getNotifyStyle("info", true), {
            css: css`
                margin: 0;
            `,
        }),
    },
    centeringWrapper: {
        css: css`
            height: 300px;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
};

export default dataTableStyles;
